/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_External_BusyInputs */

const cs_calendar_external_busy = /** @type {(inputs: Calendar_External_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Busy (externí)`)
};

const en_calendar_external_busy = /** @type {(inputs: Calendar_External_BusyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Busy (external)`)
};

/**
* | output |
* | --- |
* | "Busy (external)" |
*
* @param {Calendar_External_BusyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_external_busy = /** @type {((inputs?: Calendar_External_BusyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_External_BusyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_external_busy(inputs)
	return cs_calendar_external_busy(inputs)
});